import { ModalYesNo } from '@scripsteam/scrips-signal-ds';
/**
 * ArchiveConfirmDialog — destructive confirm for patient archive.
 *
 * Verbatim copy from Flutter `patient_list_screen.dart:946-959` (single) and
 * `:1474-1495` (bulk). Two copy variants:
 *
 *   - single (count === 1): "Do you really want to archive this account?"
 *   - bulk   (count >= 2):  "Do you really want to archive selected accounts?"
 *
 * Confirm button uses destructive styling (Flutter's `isRemove: true` flag).
 * Controlled via `open` / `onOpenChange` so callers can defer the actual
 * mutation off the Confirm click and still close the dialog on outside-click.
 */


export interface ArchiveConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  count: number;
  onConfirm: () => void;
  isPending?: boolean;
}

export function ArchiveConfirmDialog({
  open,
  onOpenChange,
  count,
  onConfirm,
  isPending = false,
}: ArchiveConfirmDialogProps) {
  const isBulk = count > 1;
  const title = isBulk
    ? 'Do you really want to archive selected accounts?'
    : 'Do you really want to archive this account?';
  const description = isBulk
    ? 'We will inform patients about this change. You can unarchive these accounts later in Account Settings.'
    : 'We will inform the patient about this change. You can unarchive this account later in Account Settings.';

  return (
    <ModalYesNo
      open={open}
      onCancel={() => onOpenChange(false)}
      title={title}
      message={description}
      cancelLabel="Cancel"
      confirmLabel={isPending ? 'Archiving…' : isBulk ? `Archive ${count}` : 'Archive'}
      onConfirm={onConfirm}
      destructive
      loading={isPending}
    />
  );
}
